import BaseEntity from '../../base/BaseEntity.model';
import SolicitudEvaluacionHogarMiembro from './miembro.model';
import SolicitudEvaluacionHogarMiembroDocumento from './documento.model';
import Direccion from '@/models/direccion.model';
import Telefono from '@/models/telefono.model';
import { MedidaTiempoEmbarazo } from '@/models/persona/persona.model';

export default class SolicitudEvaluacionHogar extends BaseEntity {
    [x: string]: any;
    public tramiteBeneficiarioId?: number;
    public nombreFamiliarFueraHogar?: string;
    public telefonoFamiliarFueraHogar?: string;
    public parentescoFamiliarFueraHogarId?: number;
    public parentescoFamiliarFueraHogarNombre?: string;
    public correos?: string;
    public listaCorreos: string[];
    public personaId?: number;
    public direccionId?: number;
    public direccion?: Direccion;
    public telefonos: Telefono[];
    public miembros: SolicitudEvaluacionHogarMiembro[];
    public estadoCivil?: string;
    public centroAcademicoOtro?: string;
    public ultimoNivelAcademico?: string;
    public centroAcademicoId?: number;
    public estaEstudiando?: boolean;
    public cursoEstudiante?: string;
    public tipoDiscapacidadId?: number;
    public discapacitado?: boolean;
    public incapacitado?: boolean;
    public esReevaluacion?: boolean;
    public lee?: boolean;
    public escribe?: boolean;
    public embarazada?: boolean;
    public tiempoEmbarazo?: number;
    public medidaTiempoEmbarazo?: MedidaTiempoEmbarazo;
    public formaCoccionAlimentos: any[];
    public formaCoccionAlimentosOtro?: string;
    public formaCoccionAlimentosOtroIsChecked = false;
    public recogenBasuraEnHogar?: boolean;
    public tienenAguaEnHogar?: boolean;
    public nivelAcademicoJefeHogarId?: number;
    public materialViviendaId?: number;
    public materialTechoViviendaId?: number;
    public materialSueloViviendaId?: number;
    public formaViviendoId?: number;
    public tipoSanitarioId?: number;
    public tipoSanitarioOtro?: string;
    public formaViviendoOtro?: string;
    public materialSueloViviendaOtro?: string;
    public materialTechoViviendaOtro?: string;
    public materialViviendaOtro?: string;
    public nivelAcademicoJefeHogarOtro?: string;
    public descripcion?: string;
    constructor() {
        super();
        this.tienenAguaEnHogar = undefined;
        this.nivelAcademicoJefeHogarId = undefined;
        this.recogenBasuraEnHogar = undefined;
        this.materialViviendaId = undefined;
        this.materialTechoViviendaId = undefined;
        this.materialSueloViviendaId = undefined;
        this.formaViviendoId = undefined;
        this.tipoSanitarioId = undefined;
        this.tipoSanitarioOtro = undefined;
        this.formaViviendoOtro = undefined;
        this.materialSueloViviendaOtro = undefined;
        this.materialTechoViviendaOtro = undefined;
        this.materialViviendaOtro = undefined;
        this.nivelAcademicoJefeHogarOtro = undefined;
        this.esReevaluacion = false;
        this.embarazada = undefined;
        this.escribe = undefined;
        this.lee = undefined;
        this.discapacitado = undefined;
        this.incapacitado = undefined;
        this.centroAcademicoId = undefined;
        this.tipoDiscapacidadId = undefined;
        this.tiempoEmbarazo = undefined;
        this.medidaTiempoEmbarazo = 0;
        this.cursoEstudiante = undefined;
        this.centroAcademicoOtro = undefined;
        this.estaEstudiando = undefined;
        this.ultimoNivelAcademico = undefined;
        this.estadoCivil = undefined;
        this.descripcion = undefined;

        
        this.tramiteBeneficiarioId = undefined;
        this.nombreFamiliarFueraHogar = undefined;
        this.telefonoFamiliarFueraHogar = undefined;
        this.parentescoFamiliarFueraHogarId = undefined;
        this.parentescoFamiliarFueraHogarNombre = undefined;
        this.correos = undefined;
        this.personaId = undefined;
        this.direccionId = undefined;
        this.direccion = undefined;
        this.miembros = [];
        this.telefonos = [];
        this.listaCorreos = [];
        this.formaCoccionAlimentos = [];
    }
}

export {
    SolicitudEvaluacionHogar,
    SolicitudEvaluacionHogarMiembro,
    SolicitudEvaluacionHogarMiembroDocumento
}
